<template>
  <div class="tab-container">
    <p>Statut de la campagne</p>
    <div class="progress-bar">
      <div class="progress" :style="`width: ${width}%`" />
      <div v-for="(step, index) in state.steps" :key="index" class="step">
        <div class="step-name" v-text="step.label" />
        <div class="dot" :class="{ passed: state.currentStep - 1 >= index }">
          <span
            v-if="index === 2 && participant.state === 1"
            v-text="`${participant.progress}%`"
          />
          <i
            v-else-if="state.currentStep - 1 >= index"
            class="bi bi-check-lg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch, computed } from "vue";

const width = computed(() => {
  state.steps.forEach((step, index) => {
    if (step.condition(state.participant) && index === state.currentStep) {
      state.currentStep++;
    }
  });

  if (state.currentStep === 0) {
    return 0;
  } else if (state.currentStep === 4) {
    return 100;
  } else {
    return state.currentStep * 25 - 12;
  }
});

const state = reactive({
  participant: {},
  currentStep: 0,
  steps: [
    {
      condition: (participant) => {
        return participant.candidate_id;
      },
      label: "Compte créé",
    },
    {
      condition: (participant) => {
        return participant.activated;
      },
      label: "Activé",
    },
    {
      condition: (participant) => {
        return participant.state >= 1;
      },
      label: "Evaluation en cours",
    },
    {
      condition: (participant) => {
        return participant.results;
      },
      label: "Résultats",
    },
  ],
});

const props = defineProps({
  participant: {
    type: Object,
    required: true,
  },
});

watch(
  props,
  () => {
    state.participant = props.participant;
  },
  { immediate: true }
);
</script>
